// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__rXLAr","total":"Cart_total__V+0IO","actions":"Cart_actions__pgiNs","button--alt":"Cart_button--alt__3NyFz","button":"Cart_button__Wxhu9"};